import { useEffect } from "react";

export function useExternalScripts(sources: readonly string[]): void {
  useEffect(() => {
    const elements = sources.map(source => {
      const script = document.createElement("script");
      script.src = source;
      document.head.append(script);
      return script;
    });

    return () => { for (const script of elements) {script.remove()} };
  }, [sources]);
}
